Object.defineProperty(exports, "__esModule", { value: true });
exports.getNavSegments = void 0;
exports.getNavSegments = (navigation, variation) => {
    const nav = navigation.find((nav) => nav.variation === variation);
    if (!nav || !nav.segments || !Array.isArray(nav.segments)) {
        return [];
    }
    return nav.segments;
};
//# sourceMappingURL=get-nav-segments.js.map